<div class="flex flex-col gap-1">
  <form
    [formGroup]="form"
    class="box-border flex py-2 px-3 gap-2 items-center rounded-[8px]"
    #phoneFieldElement
    [ngClass]="{
      hovered: hovered,
      editting: edit,
      error: form.get('input')?.errors,
    }"
    (submit)="onSubmit()"
  >
    <!-- Reference Icon -->
    <ui-icon name="phone" size="16" mSize="16" [fill]="getIconColor()" />

    <!-- Input Text Field -->
    <div class="input-container">
      <input
        #formInputField
        type="text"
        formControlName="input"
        [placeholder]="placeholder"
        uniconPhoneFormatter
      />
    </div>

    <!-- Edit Button Action -->
    <button
      *ngIf="!edit && hovered"
      type="button"
      class="flex items-center justify-center w-4 h-4"
      (click)="onEdit()"
      matTooltip="Editar"
      [disabled]="!isActivated"
    >
      <ui-icon name="edit" [fill]="getIconColor()" size="16" mSize="16" />
    </button>

    <!-- Submit Button Action -->
    <button
      *ngIf="edit"
      type="submit"
      class="flex flex-col items-center justify-center w-4 h-4 rounded-[50%]"
      [ngClass]="{
        'bg-[#FFC2C6]': !form.valid,
        'bg-unicon-yellow-100': form.valid,
      }"
      [disabled]="!form.valid"
      matTooltip="Guardar cambio"
    >
      <ui-icon name="check" fill="neutrals-900" size="16" mSize="16" />
    </button>
  </form>

  <ui-paragraph
    class="px-1 box-border"
    type="p10"
    mobile-type="p10"
    text-color="critical-300"
    font-weight="regular"
    *ngIf="form.get('input')?.hasError('required')"
  >
    Tu número de teléfono es obligatorio.
  </ui-paragraph>

  <ui-paragraph
    class="px-1 box-border"
    type="p10"
    mobile-type="p10"
    text-color="critical-300"
    font-weight="regular"
    *ngIf="form.get('input')?.hasError('pattern')"
  >
    No es un formato de teléfono válido.
  </ui-paragraph>
</div>
